import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noProjectPermissions: {
		id: 'polaris-ideas.view-content.idea-list.cell.tooltip.no-project-permissions',
		defaultMessage: 'You don’t have permissions to edit ideas from <b>{projectName}</b> project',
		description: 'Tooltip message when user don’t have the project permissions to edit the cell',
	},
});
